module.exports = __webpack_public_path__ + "img/logo_uni_baies.f676ff4f.png";